import React from "react";

const Resume = () => {
  return (
    <>
      <h1 className="resume_hello">hello Resume</h1>
    </>
  );
};

export default Resume;
